import { useTranslation } from 'next-i18next';
import Image from 'app/components/layouts/Image';
import routes from 'app/data/routes.json';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import Link from 'next/link';
import './styles.css';

const Sidebar = () => {
  const router = useRouter();
  const { t } = useTranslation();

  const navLinks = useMemo(() => {
    const filteredRoutes = routes.filter(route =>
      ['news', 'documents', 'speaking', 'listening', 'music', 'song_video', 'quotations', 'jokes', 'translate'].includes(route.name)
    );

    return filteredRoutes.map((route, index) => (
        <li
          key={index}
          className={`item-menu py-2 mt-1 cursor-pointer ${router.asPath.includes(route.path) ? 'active' : ''}`}
          style={{ marginBottom: index === filteredRoutes.length - 1 ? '70px' : '0' }}
        >
          <Link className="nav-link text-white font-weight-bold px-2 d-flex" href={route.path}>
            {route.image && (
              <Image
                width={30}
                height={30}
                disableAuto
                className="mr-3 h-auto"
                alt={route.name}
                src={route.image}
              />
            )}
            <div className="d-inline route-name">
              {t(`navigations.${route.name}`)}
              {route.description && (
                <span className="description d-block">
                  {t(`routes.${route.description}`, { text: route.name })}
                </span>
              )}
            </div>
          </Link>
        </li>
    ));
  }, [router.asPath]);

  return (
    <div id="sideBar" style={{ width: 260 }}>
      <div className="inner-wrapper-sticky" style={{ position: 'fixed', top: 60, width: 260 }}>
        <ul style={{ width: 260 }}>{navLinks}</ul>
      </div>
    </div>
  );
};

export default Sidebar;
